<template>
 <div style="flex:1 0 auto;position:relative;" v-if="canRender">
    <v-card class="ma-2 maincontent" :color="dhover?'primary lighten-5':''" @dragover.prevent="dhover = $event.dataTransfer.effectAllowed == 'all'" @dragleave.prevent="dhover=false" @drop.prevent="onImagesAdded(Array.from($event.dataTransfer.files))" >
      <v-card-title style="flex-direction:column;align-items:stretch;height:100%;" >
        <span class="subheading d-flex" style="flex:0 0 auto;">{{$t('Admin.Image.FullTitle')}} <v-spacer /><v-btn  class="flex-grow-0 cursor-pointer" small :title="$t('Admin.Image.AddImage')" color="primary" icon style="position:relative;"><v-icon>mdi-plus</v-icon><input type="file" accept="image/*" ref="fileInputs" class="docInput" multiple label="File input" @change="onImagesAdded(Array.from($event.target.files))" /></v-btn></span>                                                                                 
         <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
          <v-flex class="px-2">                  
            <draggable v-model="homeImagesConfig.images"  style="height:100%" @change="sauvegarde()">                
              <div v-for="(image,idx) in homeImagesConfig.images" style="width:200px;display:inline-block;padding:10px;border:1px solid #000;margin:5px" :class="{'selected':curentImageIdx == idx}" :key="idx">
                <v-icon class="ml-0 mr-2 pointer-move move-image" small style="flex-grow:0!important" left>mdi-cursor-move</v-icon>
                <v-btn @click.prevent="remove(idx)">{{$t('Admin.Remove')}}<v-icon right>mdi-delete</v-icon></v-btn>                                     
                <v-img contain :src="image" height="150"></v-img>                                              
              </div>
            </draggable>                          
          </v-flex>                         
        </v-layout>         
      </v-card-title>                      
    </v-card> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>          
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import draggable from 'vuedraggable'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import camelCase from 'lodash.camelcase'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { DataPoolGlobalKeys } from '@/enum/DataPool'
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'
import { HomeImagesConfig } from '@/models/datapool/HomeImagesConfig'

import {GliderCmd} from '@/models/datapool/GliderCmd'
import { directQuery } from '@/utils/api'
import apiMission from '@/api/mission'
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import { UploadStatus } from '@/enum/UploadStatus'
import { IFileUpload } from '@/models/ui/IFileUpload'


@Component({
  name: 'AdminHomeImage',
  components:{draggable}
})
export default class AdminHomeImage extends Vue {      
    
  loading = false
  filesToUpload:Array<IFileUpload> = []  
  dhover = false
  canRender = true
  status = ""
  homeImagesConfig = new HomeImagesConfig()  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_HOME_IMAGE].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }

  get dragOptions() {
      return {
        animation: 200,
        group: `nmea`,
        disabled:false,
        handle:'.move-image',
        ghostClass: "ghost"
      }
   }

  get curentImageIdx() {
    const now = new Date().getTime()
    const start = new Date(new Date().getFullYear(), 0, 0).getTime()
    const diff = now - start
    const oneDay = 1000 * 60 * 60 * 24
    const day = Math.floor(diff / oneDay)
    return day % this.homeImagesConfig?.images?.length
  }

  get originalHomeImageConfigStr() {    
    return (this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.homeImages']) as string | null || "")
  }

  get modified() {
    return JSON.stringify(this.homeImagesConfig) != this.originalHomeImageConfigStr
  }

  
  mounted(){
    this.loading = true

    this.$store.myActions.DATAPOOL_ENSURE({fullKey:DataPoolGlobalKeys['global.config.homeImages']}).then(()=>{
      this.annuler()
      this.status = this.$t('Admin.HomeImages.Loaded').toString()
    }).finally(()=>{
      this.loading = false;
    });   
    
    // window.setTimeout(()=> {
    //   console.log("test!!!")
    //   this.sauvegarde()
    // },3000)
  }

  remove(idx:number){
    this.$confirm(this.$t('Admin.DeleteDialogMessage').toString(),{title: this.$t('Admin.Warning')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {
          //@ts-ignore
          this.homeImagesConfig.images.splice(idx,1)
          this.sauvegarde()
        } 
      })    
  }
  

  /*Fonctions*/  
  sauvegarde() {
    //@ts-ignore
    this.status = this.$t('Admin.HomeImages.Loading').toString()
    this.loading = true
    this.$store.myActions.DATAPOOL_UPDATE_REQUEST(
      new AloDataPoolItem({
        dtaValue:JSON.stringify(this.homeImagesConfig),
        dtaKey:DataPoolGlobalKeys['global.config.homeImages']
      })).then((data)=>{
        this.status = this.$t('Admin.HomeImages.Loaded').toString()
        this.annuler()
      }).finally(()=>{
        this.loading = false
      })      
  }
  
  annuler() {        
    this.homeImagesConfig = HomeImagesConfig.createHomeImagesConfig(this.originalHomeImageConfigStr)    
  }


  /*
  apiMission.getImageMission(this.imgName)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            this.imagecache.src = url            
          })
  */

  async onImagesAdded(files:File[]){               
    this.dhover = false           
    if(files.length > 0){          
        const newFiles = files.filter(f => f.type.startsWith('image') &&  this.filesToUpload.every(fu => fu.file.name != f.name) ).map(f => {              
          const it = {file:f,progress:0,status:UploadStatus.waiting}                  
          return it
        })
        if(newFiles.length > 0) {         
          const imgsPromise = []  as Array<Promise<any>> 
          const erreurs = []  as Array<string> 
          for(const f of newFiles){
            if(f.file.size <= (1024 * 1000 * 2)) {
            var reader = new FileReader();            
              reader.onload = (e) => {
                const base64 = (e.target?.result as string)?.replace(/^data:image\/?[A-z]*;base64,/,'');
                const imgPromise = this.$store.myActions.MISSION_SAVE_IMAGE_REQUEST({imageData:base64,name:`home_${new Date().getMilliseconds()}.jpg`})
                imgPromise.then((r:any) => {                    
                    this.homeImagesConfig.images.push(r.url.replace('{typ}',r.typ).replace('{name}',r.name))
                }).catch(() =>{                 
                })
                imgsPromise.push(imgPromise)
                
              };            
              await reader.readAsDataURL(f.file);                      
            }
            else{
              erreurs.push(`File ${f.file.name} too big`)
            }
          }

          setTimeout(() => {
            if(imgsPromise.length > 0) {
              Promise.all(imgsPromise).then(()=>{              
                  this.sauvegarde()                
              })
            }
          }, 500);
          if(erreurs.length > 0) {
            this.$confirm(erreurs.join('. '),{title: this.$t('Admin.Warning'),buttonTrueText:"Ok",buttonFalseText:""} as VuetifyConfirmObject)
          }
        }          
    }      
    //@ts-ignore
    this.$refs.fileInputs.value = null
  }  

}
</script>
<style scoped>
.subheading,.body-2{
    font-weight: bold;  
  }

</style>